// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_NcM","cls2":"LoswpPackPitch-cls2__i- LoswpPackPitch-cls1_NcM"};